import React from 'react'
import SbEditable from 'storyblok-react'
import { TextInput } from '@/components/ui/input'

export type AllowedTextTypes =
  | 'text'
  | 'number'
  | 'email'
  | 'date'
  | 'tel'
  | 'url'
  | 'time'

export type TextInputBlok = StoryblokComponent & {
  id: string
  name: string
  label: string
  type: AllowedTextTypes
  placeholder?: string
  marginTop?: number
  marginBottom?: number
}

export interface BasicTextInputProps {
  blok: TextInputBlok
}

export const BasicTextInput = ({ blok }: BasicTextInputProps) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''

  return (
    <div
      style={{
        marginTop: marginTopClass,
        marginBottom: marginBottomClass,
      }}
    >
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok} key={blok._uid}>
        <TextInput
          id={blok.id}
          name={blok.name}
          label={blok.label}
          placeholder={blok.placeholder}
          type={blok.type}
        />
      </SbEditable>
    </div>
  )
}

BasicTextInput.displayName = 'BasicTextInput'
